import React from 'react';

import Container from '../Container';
import { BannerWrapper, HeadingText } from './styled';

export interface BannerProps {
  title: string;
  size?: 'small';
}

const Banner: React.FC<BannerProps> = ({ title, size }) => (
  <BannerWrapper size={size} data-testid='Banner'>
    <Container size='small'>
      <HeadingText data-testid='BannerHeading'>{title}</HeadingText>
    </Container>
  </BannerWrapper>
);

export default Banner;
